const state = {
    // allAgtDet: null,
    allAgentReq: null,
    allAgentRes: null,
    rejAgtReq: null,
    rejAgtRes: null,
    apprvAgtReq: null,
    apprvAgtRes: null,
    postPaidSchRes:null,
    payTypeData:null,
    actualPostSchRes:null
}

// getters
const getters = {
    GET_ACTUAL_POST_SCH_RES: (state) => {
        return state.actualPostSchRes;
    },
    GET_POSTPAID_SCH_RES: (state) => {
        return state.postPaidSchRes;
    },
    GET_PAY_TYPE_DATA: (state) => {
        return state.payTypeData;
    },
    GET_APPROVE_AGENT_REQ: (state) => {
        return state.apprvAgtReq;
    },
    GET_APPROVE_AGENT_RES: (state) => {
        return state.apprvAgtRes;
    },
    GET_REJECT_AGENT_REQ: (state) => {
        return state.rejAgtReq;
    },
    GET_REJECT_AGENT_RES: (state) => {
        return state.rejAgtRes;
    },
    GET_ALL_AGENT_REQ: (state) => {
        return state.allAgentReq;
    },
    GET_ALL_AGENT_RES: (state) => {
        return state.allAgentRes;
    },
    
}

// actions
const actions = {
    CLEAR_APPROVE_AGT_STORE: ({ commit }) => {
        commit('clearApproveAgtStore');
    },
    SET_ACTUAL_POST_SCH_RES({ commit }, schType) {
        commit('getactualPostSchRes', schType);
    },
    SET_POSTPAID_SCH_RES({ commit }, schType) {
        commit('getpostPaidSchRes', schType);
    },
    SET_PAY_TYPE_DATA({ commit }, payType) {
        commit('getPaxTypeData', payType);
    },
    SET_APPROVE_AGENT_REQ({ commit }, apprAgtDet) {
        commit('getApprvAgentReq', apprAgtDet);
    },
    SET_APPROVE_AGENT_RES({ commit }, apprAgtDet) {
        commit('getApprvAgentRes', apprAgtDet);
    },
    SET_REJECT_AGENT_REQ({ commit }, rejAgtDet) {
        commit('getRejAgentReq', rejAgtDet);
    },
    SET_REJECT_AGENT_RES({ commit }, rejAgtDet) {
        commit('getRejAgentRes', rejAgtDet);
    },
    
    
}

// mutations
const mutations = {
    clearApproveAgtStore(state){
       
        state.allAgentReq = null;
        state.allAgentRes = null;
        state.rejAgtReq= null,
        state.rejAgtRes= null,
        state.apprvAgtReq=null,
        state.apprvAgtRes= null,
        state.postPaidSchRes=null,
        state.payTypeData=null,
        state.actualPostSchRes=null
    },
    getactualPostSchRes(state, schType){
        state.actualPostSchRes = schType;
    },
    getpostPaidSchRes(state, schType){
        state.postPaidSchRes = schType;
    },
    getPaxTypeData(state, payType){
        state.payTypeData = payType;
    },
    getApprvAgentReq(state, apprAgtDet){
        state.apprvAgtReq = apprAgtDet;
    },
    getApprvAgentRes(state, apprAgtDet) {
        state.apprvAgtRes = apprAgtDet;
    },
    getRejAgentReq(state, rejAgtDet){
        state.rejAgtReq = rejAgtDet;
    },
    getRejAgentRes(state, rejAgtDet) {
        state.rejAgtRes =rejAgtDet;
    },
    getAllAgentReq(state, agentReq) {
        state.allAgentReq = agentReq
    },
    getAllAgentRes(state, agentRes) {
        state.allAgentRes = agentRes
    },
    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};